import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#F8FAFC] border-t border-slate-200 px-6 py-4 flex-shrink-0">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between">
        <p className="text-sm text-slate-600 mb-2 sm:mb-0">
          © {new Date().getFullYear()} - Help at Home, LLC
        </p>
        <div className="flex space-x-4">
          <a
            href="#"
            className="text-[#7C3AED] hover:text-[#6D28D9] text-sm transition-colors"
          >
            Privacy Policy
          </a>
          <a
            href="#"
            className="text-[#7C3AED] hover:text-[#6D28D9] text-sm transition-colors"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
